import {
    useHeaderScroll,
    getFocusableElements,
    inertElements,
} from "../common/helpers";

export const useMobileHeader = () => {
    const $body = document.querySelector(".js-ns-body");
    const $trap = document.querySelector(".js-ns-mobile-header-trap");
    const $mobileHeader = document.querySelector(".js-ns-mobile-header");
    const $navigation = document.querySelector(".js-ns-mobile-navigation");
    const $slider = document.querySelector(".js-ns-mobile-navigation-slider");
    const columns = document.querySelectorAll(
        ".js-ns-mobile-navigation-column"
    );
    const $burger = document.querySelector(".js-ns-mobile-header-burger");
    const $headerTitle = document.querySelector(".js-ns-mobile-header-title");
    const prevButtons = document.querySelectorAll(".js-ns-mobile-back");
    const history = {};

    let isInitiated = false;
    let level = 0;

    const { handleHeaderScroll } = useHeaderScroll($mobileHeader);

    const slideToLevel = () => {
        const $activeColumn = columns[level];
        const height = $activeColumn.clientHeight;

        columns.forEach(($col) => $col.setAttribute("inert", "true"));

        $activeColumn.removeAttribute("inert");

        $slider.style.transform = `translateX(-${100 * level}%)`;
        $slider.style.height = `${height}px`;
    };

    const initHeader = () => {
        try {
            const renderHeader = () => {
                if (level > 0) {
                    $mobileHeader.classList.add(
                        "ns-mobile-header--with-back-button"
                    );

                    $headerTitle.textContent = history[level];
                } else {
                    $mobileHeader.classList.remove(
                        "ns-mobile-header--with-back-button"
                    );
                }
            };

            const reRender = () => {
                slideToLevel();
                renderHeader();
            };

            const handleInertElements = (enable = true) => {
                const elements = document.querySelectorAll(
                    ".ns-header-announcement, .ns-header, .ns-content, .ns-footer, .ns-modal"
                );

                inertElements(elements, enable);
            };

            $burger.addEventListener("click", () => {
                $mobileHeader.classList.toggle("opened");
                $burger.classList.toggle("active");
                $navigation.classList.toggle("active");

                const expanded = $burger.getAttribute("aria-expanded");

                if (expanded === "false") {
                    $burger.setAttribute("aria-expanded", "true");
                    $navigation.removeAttribute("inert");
                    $burger.ariaLabel = 'Close navigation';
                    handleInertElements();
                } else {
                    $burger.setAttribute("aria-expanded", "false");
                    $navigation.setAttribute("inert", "true");
                    $burger.ariaLabel = 'Open navigation';
                    handleInertElements(false);
                }

                if ($mobileHeader.classList.contains("opened")) {
                    $body.classList.add("ns-prevent-scroll");
                } else {
                    $body.classList.remove("ns-prevent-scroll");
                }
            });

            columns.forEach(($column) => {
                const nextButtons =
                    $column.querySelectorAll(".js-ns-mobile-next");

                nextButtons.forEach(($button, index) => {
                    $button.addEventListener("click", () => {
                        const $parentColumn = $button.closest(
                            ".js-ns-mobile-navigation-column"
                        );
                        const $nextColumn = $parentColumn.nextElementSibling;
                        const blocks = $nextColumn.querySelectorAll(
                            ".js-mobile-navigation-block"
                        );
                        const title = $button.textContent;

                        blocks.forEach(($block, blockIndex) => {
                            if (index === blockIndex) {
                                $block.classList.add("active");
                                $block.removeAttribute("inert");

                                setTimeout(() => {
                                    const { $first } =
                                        getFocusableElements($block);

                                    $first.focus();
                                }, 300);
                            } else {
                                $block.classList.remove("active");
                                $block.setAttribute("inert", true);
                            }
                        });

                        level += 1;

                        history[level] = title;

                        reRender();
                    });
                });
            });

            prevButtons.forEach(($button) => {
                $button.addEventListener("click", () => {
                    if (level === 0) {
                        return;
                    }

                    level -= 1;

                    reRender();
                });
            });

            slideToLevel(0);
        } catch (e) {
            console.log(e);
        }
    };

    const init = () => {
        const windowWidth = window.innerWidth;

        if (
            !$mobileHeader ||
            !$navigation ||
            isInitiated === true ||
            windowWidth >= 1024
        ) {
            return;
        }

        initHeader();
        handleHeaderScroll();

        isInitiated = true;
    };

    const initMobileHeader = () => {
        document.addEventListener("DOMContentLoaded", init);
        window.addEventListener("resize", init);
        window.addEventListener("scroll", handleHeaderScroll);
    };

    return {
        initMobileHeader,
    };
};
